import { FormAutoGenerated } from '@visualfabriq/vf-ui-kit';
import {
  FieldItem,
  FormLayoutRow,
} from '@visualfabriq/vf-ui-kit/dist/components/molecules/form/form-auto-generated/types';
import { requiredField } from 'src/components/UIKitTweaks';

import type { TemplateFieldsForm } from '../index';

type Props = {
  initialValue: TemplateFieldsForm;
  onChange: (event: TemplateFieldsForm) => void;
};

export function TemplateFieldsForm(props: Props) {
  const { initialValue, onChange } = props;

  return (
    <FormAutoGenerated
      initData={initialValue}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onDataChange={onChange as any}
      fields={TEMPLATE_FIELDS}
      layout={TEMPLATES_FIELDS_LAYOUT}
    />
  );
}

const TEMPLATE_FIELDS: FieldItem[] = [
  {
    ...requiredField,
    field_id: 'label',
    field_desc: 'Label',
    data_type: 'text',
  },
  {
    ...requiredField,
    field_id: 'description',
    field_desc: 'Description',
    data_type: 'text',
  },
  {
    field_id: 'mandatory',
    field_desc: 'Mandatory',
    data_type: 'boolean',
  },
  {
    field_id: 'zendesk_url',
    field_desc: 'Zendesk Url',
    data_type: 'text',
  },
  {
    field_id: 'category',
    field_desc: 'Category',
    data_type: 'text',
    edit_dependencies: [
      {
        field_id: 'mandatory',
        values: [false],
      },
    ],
  },
];
const TEMPLATES_FIELDS_LAYOUT: FormLayoutRow[] = TEMPLATE_FIELDS.map((field) => [
  { field: field.field_id, cols: [4, 6, 12] },
]);
